import React, { RefObject } from 'react';
import { Flower2Icon, LeafIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { images } from '../../data/content';
type HeroProps = {
  ctaRef: RefObject<HTMLDivElement>;
};
export function Hero({
  ctaRef
}: HeroProps) {
  return <header className="bg-cream px-5 pb-14 pt-6 sm:pt-10" data-id="element-202" data-mp="hvz21tch56dc">
      <div className="mx-auto max-w-5xl text-center" data-id="element-203" data-mp="mu0q6sorbvvo">
        <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-204" data-mp="mtisrsqczbm6">
          <div className="flex items-center gap-2" data-id="element-205" data-mp="qub4qtqm7um5">
            <span className="grid h-9 w-9 place-items-center rounded-lg bg-brand-700 text-white" data-id="element-206" data-mp="vmcb5z13qr49">
              <Flower2Icon className="h-5 w-5" aria-hidden="true" data-id="element-207" data-mp="10lfgzlowp1da" />
            </span>
            <span className="font-display text-xl font-bold text-brand-800" data-id="element-208" data-mp="10n9tqcq0xn6a">
              7D Apometry<sup className="text-[10px]" data-id="element-209" data-mp="15ifdp5zv8rrq">™</sup>
            </span>
          </div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-wide text-brand-700 ring-1 ring-brand-100" data-id="element-210" data-mp="1ak4nyjf9l1er">
            <LeafIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-211" data-mp="4nogbz3kt8mx" />7 days · 15 min a day
          </span>
        </div>

        <p className="mt-6 text-[13px] font-bold uppercase tracking-[0.14em] text-brand-600" data-id="element-212" data-mp="3vvj3w3ku5goh">
          Learn to practice Apometry in a simple, guided and structured way
        </p>
        <h1 className="mx-auto mt-3 max-w-4xl font-display text-[34px] font-extrabold leading-[1.08] text-ink sm:text-6xl" data-id="element-213" data-mp="sd920pr46jzw">
          7 Days to Begin Working on Spiritual Blockages,{' '}
          <em className="text-brand-700" data-id="element-214" data-mp="inph7ejucg2e">Harmonization &amp; Protection</em>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-[17px] leading-relaxed text-ink-soft sm:text-xl" data-id="element-215" data-mp="enff4cz669st">
          A practical routine inspired by Apometry principles, organized into{' '}
          <strong className="text-ink" data-id="element-216" data-mp="16ebqf95l06dz">7 days and 15 minutes per day</strong>, so you can stop collecting information
          and finally have a clear structure to follow from day one.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[16px] leading-relaxed text-ink-soft sm:text-lg" data-id="element-217" data-mp="35l0i9tb6cf45">
          Includes <strong className="text-ink" data-id="element-218" data-mp="2qwdxvd6owx62">6 premium volumes</strong>,{' '}
          <strong className="text-ink" data-id="element-219" data-mp="2qu9t6t0yvu4q">21 guided practices</strong>, checklists, a 7-day calendar and{' '}
          <strong className="text-ink" data-id="element-220" data-mp="2vsulm69z99im">5 exclusive bonuses</strong>.
        </p>

        <figure className="-mx-5 mt-8 sm:mx-auto sm:max-w-3xl" data-id="element-221" data-mp="2hu4o4pj8x7tq">
          <img src={images.mockup} alt="The 6 volumes and 5 bonuses of the 7D Apometry Protocol" className="h-auto w-full" data-id="element-222" data-mp="2mvk5a6iayu6u" />
          <figcaption className="mt-2 px-5 text-sm font-semibold text-brand-700" data-id="element-223" data-mp="2cw315tip8ocz">
            The 6 Volumes + 5 Bonuses of the 7D Apometry Protocol™
          </figcaption>
        </figure>

        <div ref={ctaRef} className="mt-8" data-id="element-224" data-mp="b4zokyp90zps">
          <CtaButton label="I want to start the 7D Protocol™" microcopy="Instant download · One-time payment of $27 USD · Lifetime access · 7-day guarantee" data-id="element-225" data-mp="b3op3b2u6e4h" />
        </div>
        <Countdown data-id="element-226" data-mp="1qpiiy65ebjri" />
      </div>
    </header>;
}